import React, { useEffect, useRef, useState } from 'react';
import { CustomerDocumentModelItem, TreatmentType } from '../../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faFile, faFileExcel, faFilePdf, faFileWord, faImage } from '@fortawesome/free-regular-svg-icons';
import { Dropdown, MenuProps, Tooltip } from 'antd';
import EditDocumentModal from './_EditDocumentModal';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import MessegePopup from '../../subscribers/popups/_MessegePopup';
import DeleteAlert from '../../components/DeleteAlert';
import { set } from 'lodash';
import ClientDocumentPopup from './_ClientDocumentPopup';
import { setFileDocumentsUrl, setTaskFileFromDocument } from '../../app-context/filesSlice';
import { useDispatch } from 'react-redux';
import { setCreateTreatmentFrom } from '../../app-context/tasksSlice';
import { setSueInsuranceCompanyId } from '../../app-context/suesSlice';
import CopyFiles from '../../components/_CopyFiles';


type Props = {
    documentDetails: CustomerDocumentModelItem;
    config: any;
    loadData: () => void;
    fromPolicy?: boolean;
    policyId?: string;
    fromSigning?: boolean;
    showAddTreatmentPopup: (type: number) => void;
};

const ClientDocument = (props: Props) => {
    const dispatch = useDispatch();
    const customerCardModel = useRef(new CustomerCardModel()).current;

    const [dropdownItems, setDropdownItems] = useState<MenuProps['items']>([]);
    const [documentItem, setDocument] = useState<CustomerDocumentModelItem>(props.documentDetails);
    const [apiUrl, setApiUrl] = useState<string>(props.config.apiUrl);

    const [showModelUploadDocument, setShowModelUploadDocument] = useState<{ show: boolean, customerId: string }>({ show: false, customerId: '' });

    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [warnningDeleteFile, setWarnningDeleteFile] = useState<boolean>(false);
    const [fileTitleTypes, setFileTitleTypes] = useState<any[]>([]);

    const [clientDocumentUrl, setClientDocumentUrl] = useState<string | null>(null)
    const [relationList, setRelationList] = useState<any[]>([]);

    const [showPopUpCopyFiles, setShowPopUpCopyFiles] = useState<boolean>(false);

    const onMenuClicked = async (action: string) => {
        switch (action) {
            case '_DisplayDoc_':
                displayDocument();
                break;

            case '_DownloadDoc_':
                downloadDocument();
                break;

            case '_EditDoc_':
                editDocument();
                break;

            case '_DeleteDoc_':
                setWarnningDeleteFile(true);
                setMessage('האם אתה בטוח שברצונך למחוק את המסמך?');
                break;
            case '_CopyFile':
                // Logic to copy/move file goes here
                setShowPopUpCopyFiles(true);
                console.log(`Copying/Moving file with ID: ${documentItem.id}`);
                break;


            default:
                break;
        }
        emptyFunc()
    }
    // .indexOf('http://')>-1

    const displayDocument = () => {
        let documentUrl = '';
        if (documentItem.filePath && (documentItem.filePath.indexOf('http://') > -1 || documentItem.filePath.indexOf('https://') > -1)) {
            documentUrl = documentItem.filePath;
        } else {
            documentUrl = apiUrl + documentItem.filePath;
        }
        console.log('displayDocument-documentUrl', documentUrl)
        if (props.fromSigning && props.config.displayFile) {
            props.config.displayFile(documentItem);
        } else if (documentUrl) {
            dispatch(setFileDocumentsUrl(documentUrl));
            // setClientDocumentUrl(documentUrl);
        }
    }

    const editDocument = () => {
        setShowModelUploadDocument({ show: true, customerId: documentItem.customerId || '' });
    }


    const deleteDocument = async () => {
        const res = await customerCardModel.customerDocumentsDeleteFile(documentItem.id || '');

        if (res) {
            console.log('Document deleted successfully:', res);
        } else {
            console.error('Failed to delete document:', res);
        }
    }


    const downloadDocument = () => {
        let documentUrl = '';
        if (documentItem.filePath && (documentItem.filePath.indexOf('http://') > -1 || documentItem.filePath.indexOf('https://') > -1)) {
            documentUrl = documentItem.filePath;
        } else {
            documentUrl = apiUrl + documentItem.filePath;
        }

        if (apiUrl !== '' && documentUrl) {
            const fileUrl = `${documentUrl}`;
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target = '_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const initDataWithAsync = async () => {

        let fileTitleTypesStorage = localStorage.getItem('customerDocumentsTitle');
        if (fileTitleTypesStorage) {
            const titles = JSON.parse(fileTitleTypesStorage);
            setFileTitleTypes(titles);
        } else {
            const titles = await customerCardModel.customerDocumentsGetTitles();
            if (titles) {
                setFileTitleTypes(titles);
                localStorage.setItem('customerDocumentsTitle', JSON.stringify(titles));
            } else {
                console.error('Failed to fetch titles:', titles);
                setFileTitleTypes([]);
            }
        }
        // }

        let relationDate = null;
        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${props.documentDetails.customerId || ""}`);
        if (storedRelations) {
            relationDate = JSON.parse(storedRelations);
            console.log('storedRelations-relationDate-157', relationDate)
        } else {

            relationDate = await customerCardModel.treatmentsLoadRelations(props.documentDetails.customerId || "");
            sessionStorage.setItem(`treatmentsRelations-${props.documentDetails.customerId || ""}`, JSON.stringify(relationDate));
        }

        if (relationDate) {

            let leadsList = relationDate.leads.map((lead: any) => ({
                id: lead.id,
                name: lead.identifier || '',
                type: 'Lead',
            }));
            let policiesList = relationDate.policies.map((policy: any) => ({
                id: policy.id,

                name: `פוליסה: ${policy.compulsoryRouteId ? policy.compulsoryRouteId + '-' : ''}${policy.policyNumber}
             חברה: ${policy.insuranceCompanyId ? getInsuranceCompanieById(policy.insuranceCompanyId) : ''} ` || '',

                type: 'Policy',
            }));
            let suesList = relationDate.sues.map((sue: any) => ({
                id: sue.id,
                name: `מספר תביעה ${sue.sueNumber} חברה: ${sue.insuranceCompany && sue.insuranceCompany.name ? sue.insuranceCompany.name : ""} ` || '',
                type: 'Sue',
            }));
            let riderList = relationDate.riders.map((rider: any) => ({
                id: rider.id,
                name: `מנוי ${rider.subscriberNumber}` || '',
                type: 'Rider',
            }));

            let newlist = [...leadsList, ...policiesList, ...suesList, ...riderList]
            setRelationList(newlist);
        }

    }

    useEffect(() => {
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
    }, [props])


    const onAddOfferOptionClick = (type: number) => {
        console.log('onAddOfferOptionClick-showAddTreatmentPopup', 111)
        dispatch(setTaskFileFromDocument(props.documentDetails))
        if (props.policyId) {
            dispatch(setCreateTreatmentFrom({ type: 'policy', id: props.policyId }));
        }
        props.showAddTreatmentPopup(type);

    }

    useEffect(() => {

        let items = [
            {
                key: '1',
                label: (
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('_DisplayDoc_') }}
                    >
                        הצגת מסמך
                    </div>
                ),
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('_EditDoc_') }}
                    >
                        ערוך
                    </div>,
                key: '2',
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('_DownloadDoc_') }}
                    >
                        הורד למחשב
                    </div>,
                key: '6',
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('_DeleteDoc_') }}
                    >
                        מחק
                    </div>,
                key: '3',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => onMenuClicked('_CopyFile')}
                    >
                        העברת קובץ
                    </li>,
                key: 'sentToTipul'
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => onAddOfferOptionClick(TreatmentType._1)}
                    >
                        יצירת משימה
                    </li>,
                key: 'sentToTipulShitef'
            },

        ]
        const logger = localStorage.getItem('loggedUser');
        if (logger) {
            const user = JSON.parse(logger);
            if (user && user.id) {
                if (user.role != 0) {
                    items = items.filter(item => item.key !== '3'); // Remove edit option for non-admin users
                }
            }
        }

        setDropdownItems(items);
        initDataWithAsync();

    }, [])



    const emptyFunc = () => { }

    const getCreatedBy = (userId: string) => {
        const users = localStorage.getItem('usersList');
        if (users) {
            const usersList = JSON.parse(users);
            const user = usersList.find((u: any) => u.id === userId);
            if (user) {
                return user.fullName;
            }
        }
        return 'לא ידוע';
    }

    const getIcon = (fileName: string) => {
        if (/\.pdf$/i.test(fileName)) {
            return faFilePdf;
        } else if (/\.doc$/i.test(fileName) || /\.docx$/i.test(fileName)) {
            return faFileWord;
        } else if (/\.xls$/i.test(fileName) || /\.xlsx$/i.test(fileName)) {
            return faFileExcel;
        } else if (/\.png$/i.test(fileName) || /\.jpg$/i.test(fileName) || /\.jpeg$/i.test(fileName) || /\.gif$/i.test(fileName)) {
            return faImage;
        } else {
            return faFile;
        }
    }

    const onClose = () => {
        setShowPopUpMessage(false);
        props.loadData()
    }

    const getTitleInfo = (idTitle: string) => {
        const title = fileTitleTypes.find((x: any) => x.id === idTitle);
        if (title) {
            return title.name;
        }
        return '';
    }

    const hideClientDocument = () => {
        setClientDocumentUrl(null)
    }

    const getRelationInfo = (idRelation: string) => {

        let relationInfo = documentItem.documentRelations && documentItem.documentRelations.length > 0 &&
            documentItem.documentRelations.find(x => x.type != 6);
        console.log('getRelationInfo-relationList', relationList)
        console.log('getRelationInfo-documentItem.documentRelations', documentItem.documentRelations)
        console.log('getRelationInfo-relationInfo', relationInfo)
        if (relationInfo) {
            const relation = relationList.find((x: any) => x.id === relationInfo.relationId);
            console.log('getRelationInfo-relation', relation)
            if (relation) {

                return relation.name;
            }
        }
        return '';
    }

    const getInsuranceCompanieById = (companyId: string) => {
        let insuranceCompaniesList = localStorage.getItem('insuranceCompanies');
        let insuranceCompanies: any[] = [];
        if (insuranceCompaniesList) {
            insuranceCompanies = JSON.parse(insuranceCompaniesList);
            let company = insuranceCompanies.find((company: any) => company.value == companyId);
            return company.label;
        }
        return '';
    }

    const getRelationTypeInfo = () => {
        if (props.documentDetails.documentRelations && props.documentDetails.documentRelations.length > 0) {
            let relationDataList = props.documentDetails.documentRelations.filter(x => x.type !== 6);

            if (relationDataList && relationDataList.length > 0) {
                let relationStrings = relationDataList.map(relationData => {
                    if (relationData.type === 2) {
                        return `פוליסה: ${relationData.relation && relationData.relation.policyNumber || ''}, חברה: ${relationData.relation && relationData.relation.insuranceCompanyId
                            ? getInsuranceCompanieById(relationData.relation.insuranceCompanyId) : ''}`;
                    } else if (relationData.type === 3) {
                        return `מנוי: ${relationData.relation ? relationData.relation.subscriberNumber : ''}`;
                    } else if (relationData.type === 4) {
                        return `תביעה: ${relationData.relation && relationData.relation.sueNumber || ''}, חברה: ${relationData.relation && relationData.relation.insuranceCompanyId
                            ? getInsuranceCompanieById(relationData.relation.insuranceCompanyId) : ''}`;
                    } else if (relationData.type === 0) {
                        return `ליד: ${relationData.relation.identifier || ''}`;
                    } else if (relationData.type === 1) {
                        return `הצעה: ${relationData.relation.identifier || ''}`;
                    } else {
                        return '';
                    }
                });

                // Join with <br/> for separate rows
                return relationStrings.join('<br/>');
            }
        }
        return '';
    };

    return (
        <>

            {showPopUpCopyFiles &&
                <CopyFiles documentDetails={documentItem} onClose={() => setShowPopUpCopyFiles(false)} loadData={props.loadData} />
            }


            {clientDocumentUrl != null ?
                (
                    <ClientDocumentPopup
                        ClosePopup={hideClientDocument}
                        documentUrl={clientDocumentUrl}
                    />
                ) : ""
            }

            {
                showPopUpMessage &&
                <MessegePopup
                    message={message}
                    statusMessege='success'
                    show={showPopUpMessage}
                    onClose={onClose}
                />
            }

            {showModelUploadDocument.show &&
                <EditDocumentModal
                    onClose={() => {
                        setShowModelUploadDocument({ show: false, customerId: '' })
                    }}
                    onCloseAfterSave={() => {
                        setMessage('מסמך עודכן בהצלחה');
                        setShowPopUpMessage(true);
                        setShowModelUploadDocument({ show: false, customerId: '' });

                    }}
                    config={{ customerId: showModelUploadDocument.customerId, file: documentItem }}
                    fromPolicy={props.fromPolicy || false}
                />

            }

            {warnningDeleteFile && (
                <DeleteAlert
                    show={warnningDeleteFile}
                    onClose={() => setWarnningDeleteFile(false)}
                    onConfirm={async () => {
                        setWarnningDeleteFile(false);
                        await deleteDocument();
                        await props.loadData()
                    }}
                />
            )}
            <Dropdown menu={{ items: dropdownItems }} trigger={['contextMenu']}>
                <div className="data-card"
                    onDoubleClick={() => onMenuClicked('_DisplayDoc_')}
                    style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div style={{ width: '50px' }}>
                        <Tooltip placement="bottom" title={'לא ניתן ראות נתוני הסבר נוספים'}>
                            <FontAwesomeIcon icon={faLink} />
                        </Tooltip>
                    </div>

                    <div style={{ width: '170px' }}>
                        <div className="cell-value flex">
                            <div className='icon-holder'>
                                <FontAwesomeIcon icon={getIcon(documentItem.name || '')} />
                            </div>

                            <Tooltip placement="bottom" title={documentItem.name}>
                                <div className='description cell-value' style={{ fontWeight: 'bold' }}>
                                    {"   -   "} {documentItem.name}
                                </div>
                            </Tooltip>
                        </div>

                    </div>
                    <div style={{ width: '250px' }}>
                        {/* {documentItem.documentRelations && documentItem.documentRelations.length > 0 ? getRelationTypeInfo() : ''} */}
                        <div dangerouslySetInnerHTML={{ __html: getRelationTypeInfo() }} />
                    </div>

                    <div style={{ width: '170px' }}>
                        {getTitleInfo(documentItem.titleId || '')}
                    </div>
                    <div style={props.fromSigning === true ? { display: 'none' } : { width: '170px' }}>

                        <Tooltip placement="bottom" title={documentItem.comment}>
                            <div className='description'>
                                {documentItem.comment || ''}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={props.fromSigning === true ? { display: 'none' } : { width: '170px' }}>
                        <div className="description">
                            <p>{(Number(documentItem.fileSize) / 1024).toFixed(2)} KB</p>
                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <div className="description">
                            {getCreatedBy(documentItem.userId || '')}
                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <div className="description cell-value bold">
                            {moment(documentItem.createdDate).format('DD-MM-YYYY')}
                        </div>
                        <div className="description">
                            {moment(documentItem.createdDate).format('HH:mm')}
                        </div>
                    </div>

                    <div style={{ width: '170px' }}>
                        <Dropdown menu={{ items: dropdownItems }}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>
                    </div>
                </div>
            </Dropdown>
        </>

    )
}

export default ClientDocument;